export default __webpack_public_path__ + "static/media/startlater_2@3x.feef50ce.jpg";